<!-- Przycisk zamknij -->
<button mat-icon-button [mat-dialog-close]="null"
    class="!absolute !top-3 !right-3 !w-9 !h-9 text-gray-400 hover:text-gray-500 dark:text-gray-500 dark:hover:text-gray-400 transition-colors !z-10">
    <mat-icon [svgIcon]="'tabler_outline:x'" class="!w-5 !h-5"></mat-icon>
</button>

<!-- Nagłówek - wycentrowany, premium -->
<div class="flex flex-col items-center pt-8 px-8 pb-2">
    <!-- Ikona w kwadracie -->
    <div class="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mb-4">
        @if (data.method === 'email' && !useRecoveryKey) {
            <mat-icon [svgIcon]="'tabler_outline:mail'" class="text-primary !w-7 !h-7"></mat-icon>
        } @else if (useRecoveryKey) {
            <mat-icon [svgIcon]="'tabler_outline:key'" class="text-primary !w-7 !h-7"></mat-icon>
        } @else {
            <mat-icon [svgIcon]="'tabler_outline:device-mobile'" class="text-primary !w-7 !h-7"></mat-icon>
        }
    </div>

    <h2 class="text-xl font-bold text-gray-900 dark:text-white m-0 text-center">
        @if (useRecoveryKey) {
            Klucz odzyskiwania
        } @else {
            Weryfikacja dwuetapowa
        }
    </h2>

    <p class="text-sm text-gray-500 dark:text-gray-400 mt-2 mb-0 text-center leading-relaxed">
        @if (useRecoveryKey) {
            Wprowadź jeden z zapisanych kluczy odzyskiwania
        } @else if (data.method === 'authenticator') {
            Wprowadź 6-cyfrowy kod z aplikacji&nbsp;uwierzytelniającej
        } @else {
            Wprowadź 6-cyfrowy kod wysłany na&nbsp;Twój&nbsp;adres&nbsp;e-mail
        }
    </p>
</div>

<mat-dialog-content class="!px-6 !pt-5 !pb-0">
    @if (!useRecoveryKey) {
        <!-- Badge z adresem email -->
        @if (data.method === 'email' && data.maskedEmail) {
            <div class="flex items-center justify-center gap-2 rounded-lg py-2 px-3.5 mb-5 mx-auto w-fit bg-primary/5 dark:bg-primary/10">
                <mat-icon [svgIcon]="'tabler_outline:mail-check'" class="text-primary !w-4 !h-4 flex-shrink-0"></mat-icon>
                <span class="text-sm text-primary font-medium">{{ data.maskedEmail }}</span>
            </div>
        }

        <!-- Inputy kodu z separatorem XXX - XXX -->
        <div class="flex justify-center my-4">
            <div class="code-inputs">
                @for (i of [0,1,2,3,4,5]; track i) {
                    @if (i === 3) {
                        <div class="code-separator">
                            <div class="w-2 h-0.5 rounded-full bg-gray-300 dark:bg-gray-600"></div>
                        </div>
                    }
                    <input
                        #codeInput
                        type="text"
                        maxlength="1"
                        inputmode="numeric"
                        autocomplete="one-time-code"
                        class="code-input"
                        [class.has-error]="error"
                        [class.is-filled]="filledInputs[i]"
                        placeholder="·"
                        (input)="onCodeInput($event, i)"
                        (keydown)="onCodeKeydown($event, i)"
                        (paste)="onCodePaste($event)"
                        (focus)="onInputFocus()"
                    />
                }
            </div>
        </div>

        <!-- Komunikat błędu z animacją -->
        <div class="error-message" [class.visible]="error">
            <mat-icon [svgIcon]="'tabler_outline:alert-circle'" class="!w-3.5 !h-3.5"></mat-icon>
            <span>{{ error }}</span>
        </div>

        <!-- Wyślij ponownie dla email -->
        @if (data.method === 'email') {
            <div class="flex items-center justify-center mt-4 mb-2">
                @if (resendTimer > 0) {
                    <span class="text-xs text-gray-400 dark:text-gray-500 tabular-nums tracking-wide">
                        Wyślij ponownie za {{ resendTimer }}s
                    </span>
                } @else {
                    <button
                        class="inline-flex items-center gap-1.5 text-xs text-primary/70 hover:text-primary font-medium transition-colors"
                        [disabled]="isResending"
                        (click)="resendCode()">
                        @if (isResending) {
                            <mat-spinner diameter="12"></mat-spinner>
                        } @else {
                            <mat-icon [svgIcon]="'tabler_outline:refresh'" class="!w-3.5 !h-3.5"></mat-icon>
                        }
                        Wyślij ponownie
                    </button>
                }
            </div>
        }
    } @else {
        <!-- Tryb klucza odzyskiwania -->
        <div class="max-w-[320px] mx-auto">
            <div class="flex items-start gap-2.5 bg-amber-50 dark:bg-amber-950/30 border border-amber-200/60 dark:border-amber-800/30 rounded-lg p-3 mb-4">
                <mat-icon [svgIcon]="'tabler_outline:alert-triangle'" class="text-amber-500 dark:text-amber-400 !w-4 !h-4 flex-shrink-0 mt-0.5"></mat-icon>
                <p class="text-xs text-amber-700 dark:text-amber-400/80 m-0 leading-relaxed">
                    Klucze są jednorazowe. Po użyciu wygeneruj nowe.
                </p>
            </div>

            <mat-form-field class="w-full" appearance="outline">
                <mat-label>Klucz odzyskiwania</mat-label>
                <input
                    matInput
                    [(ngModel)]="recoveryKey"
                    placeholder="XXXX-XXXX-XXXX"
                    class="!font-mono !uppercase !tracking-wider !text-center"
                    (keyup.enter)="verifyRecoveryKey()"
                />
                <mat-icon matPrefix [svgIcon]="'tabler_outline:key'" class="text-gray-400 mr-2"></mat-icon>
            </mat-form-field>

            @if (error) {
                <div class="flex items-center justify-center gap-1.5 text-red-500 text-xs font-medium -mt-2 mb-2">
                    <mat-icon [svgIcon]="'tabler_outline:alert-circle'" class="!w-3.5 !h-3.5"></mat-icon>
                    <span>{{ error }}</span>
                </div>
            }
        </div>
    }
</mat-dialog-content>

<mat-dialog-actions class="!px-6 !pb-6 !pt-3 !flex !flex-col !items-center !gap-3">
    <!-- Główny przycisk -->
    @if (!useRecoveryKey) {
        <button
            mat-flat-button
            color="primary"
            class="verify-btn !h-12 !rounded-xl !text-sm !font-semibold !min-w-[200px] !max-w-[280px] !w-full !px-8"
            [disabled]="code.length !== 6 || isProcessing"
            (click)="verify()">
            <span class="verify-btn-content">
                @if (isProcessing) {
                    <mat-spinner diameter="18" class="verify-btn-spinner"></mat-spinner>
                    <span>Weryfikuję...</span>
                } @else {
                    <span>Zweryfikuj</span>
                }
            </span>
        </button>
    } @else {
        <button
            mat-flat-button
            color="primary"
            class="verify-btn !h-12 !rounded-xl !text-sm !font-semibold !min-w-[200px] !max-w-[320px] !w-full !px-8"
            [disabled]="!recoveryKey || isProcessing"
            (click)="verifyRecoveryKey()">
            <span class="verify-btn-content">
                @if (isProcessing) {
                    <mat-spinner diameter="18" class="verify-btn-spinner"></mat-spinner>
                    <span>Weryfikuję...</span>
                } @else {
                    <span>Użyj klucza odzyskiwania</span>
                }
            </span>
        </button>
    }

    <!-- Przełącznik: kod <-> klucz odzyskiwania -->
    <button
        class="inline-flex items-center justify-center gap-1.5 text-xs text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 font-medium transition-colors py-1 self-center"
        (click)="toggleMode()">
        @if (!useRecoveryKey) {
            <mat-icon [svgIcon]="'tabler_outline:key'" class="!w-3.5 !h-3.5"></mat-icon>
            Użyj klucza odzyskiwania
        } @else {
            <mat-icon [svgIcon]="'tabler_outline:arrow-left'" class="!w-3.5 !h-3.5"></mat-icon>
            Wróć do kodu weryfikacyjnego
        }
    </button>
</mat-dialog-actions>
